import React, {Fragment} from 'react';
import {Icons, Popup} from 'components';
import {noop, xor, shorten, openPopup, useNamedSelector, includes} from 'helpers';
import {set} from 'store/settings';

export function SidebarPreferences() {
  return (
    <Fragment>
      <Icons.Sort title="Sort by" onClick={openPopup(SortSettings)} />
      <Icons.Settings title="Settings" onClick={openPopup(DisplaySettings)} />
    </Fragment>
  );
}

function SortSettings() {
  const { sort } = useNamedSelector('notes.settings');
  return (
    <Fragment>
      <b>Sort by</b>
      <Popup.Menu>
        <Popup.Menu.Radio onClick={() => set({ value: 'newest', module: 'notes', key: 'sort' })} checked={sort == 'newest'}>Newest first</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ value: 'oldest', module: 'notes', key: 'sort' })} checked={sort == 'oldest'}>Oldest first</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ value: 'tags', module: 'notes', key: 'sort' })} checked={sort == 'tags'}>Tags</Popup.Menu.Radio>
      </Popup.Menu>
    </Fragment>
  );
}

function DisplaySettings() {
  const { blacklist, categories } = useNamedSelector('notes.settings');
  return (
    <Fragment>
      <b>Categories</b>
      <Popup.Menu onClick={noop}>
        { categories.map(category =>
          <Popup.Menu.Checkbox key={category.id}
            onClick={() => set({ module: 'notes', key: 'blacklist', value: xor(blacklist, [ category.id ]) })}
            checked={!includes(blacklist, category.id)}
            children={shorten(category.name || 'Untitled', { words: 8 })}
          />
        ) }
      </Popup.Menu>
    </Fragment>
  );
}
